/* @flow */
type StringOrStringsOrNull = string | string[] | void;

function getMatcher(query: string) {
  const words = query.toLowerCase().split(/\W+/);
  const match = (item: string) => item && words.every(word => item.toLowerCase().includes(word));
  return (terms: StringOrStringsOrNull[]): boolean => terms.some(item => item && (Array.isArray(item) ? item.some(match) : match(item)));
}

export default getMatcher;



// WEBPACK FOOTER //
// ./src/utils/getMatcher.js